<template>
  <!-- 遮罩 begin -->
  <MaskLayer
    class="position-absolute"
    style="max-height: 100%"
  >
    <!-- 獎品名稱 begin -->
    <div
      class="bg-white p-3 px-md-4 d-flex flex-column rounded-md text-center"
      style="width: 90%; max-width: 560px; max-height: 95vh"
    >
      <h5
        v-if="item.isPrize"
        class="font-weight-normal"
      >
        {{ $t("activity.congratuation-on-getting") }}
      </h5>
      <!-- 禮品-上稿 begin -->
      <h2 class="font-weight-normal">
        {{ item.itemInfo.name }}
      </h2>
      <!-- 禮品-上稿 end -->
      <!-- 禮品-預覽 begin -->
      <div class="m-auto image-panel image-panel-5 bg-none my-2">
        <img
          :src="item.itemInfo.image"
          alt=""
        >
      </div>
      <!-- 禮品-預覽 end -->
      <div class=" font-size-md text-gray600">
        {{ $t("activity.endtime") + endTime + $t("activity.end") }}
      </div>
      <div>
        <b-button
          pill
          :style="{
            background: `rgba(${entertainmentInfo.resultColor}, 0.75)`,
            'border-color': `rgba(${entertainmentInfo.resultColor}, 1.0)`,
            color: `rgba(${
              entertainmentInfo.resultColor === '255,255,255'
                ? '45,167,193'
                : '255,255,255'
            },1.0)`,
          }"
          class="my-3 w-100"
          @click="goToMemberCenterWithCode"
        >
          {{ buttonWording }}
        </b-button><!-- 行動呼籲按鈕, 形狀：pill/空值/squared -->
      </div>
    </div>
    <!-- 獎品名稱 end -->
  </MaskLayer>
  <!-- 遮罩 end -->
</template>

<script>
import { mapActions, mapState } from 'vuex';
import MaskLayer from '@/components/MaskLayer.vue';

export default {
  components: {
    MaskLayer,
  },
  props: {
    // 中獎商品資訊
    item: {
      type: Object,
      require: true,
      default: () => ({}),
    },
    // 活動資料
    activity: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      endTime: 0,
    };
  },
  computed: {
    ...mapState(['companyId', 'memberSourceId', 'isMobile']),
    // 娛樂活動資料(刮刮樂...)
    entertainmentInfo() {
      const vm = this;
      switch (vm.activity.categoryID) {
        // 刮刮樂
        case 'Scratchoff':
          return vm.activity.scratchOffInfo;
        // 拉霸
        case 'Slot':
          return vm.activity.slotInfo;
        case 'Roulette':
          return vm.activity.rouletteInfo;
        default:
          return {};
      }
    },
    buttonWording() {
      return this.$t('activity.goToCheck');
    },
  },
  created() {
    const time = new Date(this.item.itemInfo.coupon[0].expiredTime);
    this.endTime = `${time.getFullYear()}/${(time.getMonth() + 1).toString().padStart(2, '0')}/${time.getDate().toString().padStart(2, '0')} ${time.getHours().toString().padStart(2, '0')}:${time.getMinutes().toString().padStart(2, '0')}`;
  },
  methods: {
    // 前往查看按鈕
    ...mapActions('sso', ['postDynamicLogin']),
    goToMemberCenterWithCode() {
      const memberAcntNo = sessionStorage.getItem('memberAcntNo');
      const memberID = sessionStorage.getItem('memberId');
      const validData = {
        companyID: this.companyId,
        memberSourceID: this.memberSourceId,
        memberAcntNo: Number(memberAcntNo),
        memberID,
        device: this.isMobile ? 'mobile' : 'pc',
      };
      this.postDynamicLogin(validData).then((res) => {
        sessionStorage.removeItem('code');
        sessionStorage.removeItem('memberId');
        sessionStorage.removeItem('memberAcntNo');
        if (res && res.response.success) {
          const params = {
            companyid: this.companyId,
            membersourceid: this.memberSourceId,
            code: res.response.data[0].code,
          };
          const queryString = new URLSearchParams(params).toString();
          const href = `${window.location.origin}/rewards/membercenter/mcfwallet?${queryString}`;

          window.location.href = href;
        } else {
          const params = {
            companyid: this.companyId,
            membersourceid: this.memberSourceId,
          };
          const queryString = new URLSearchParams(params).toString();
          const href = `${window.location.origin}/rewards/membercenter/mcfwallet?${queryString}`;

          window.location.href = href;
        }
      });
    },
  },
};
</script>
